import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import template from "./date_range_facet.html";

function DateRangeFacet(search_model, facet, expanded, active, custom) {
Object.assign(this,  {
    "type": "daterange",
    "template": template,
    "caption": facet.caption,
    "name": facet.name,
    "field": facet.field,
    "icon": facet.icon || "fa-calendar",
    "colour": facet.colour || "light-sea-green",
    "custom": custom,
    "data": ko.observable([null, null]),
    "before": ko.observable(null),
    "after": ko.observable(null),
    "selected": active.indexOf(facet.name) >= 0,
    "visible": ko.observable(true)
});
var f = this;
if (this.selected) {
    var datum = search_model.faceting.active()[active.indexOf(facet.name)];
    if (datum) {
        this.data(datum.range);
    }
}
this.select_range = function (start, end) {
    //var selector = facet.name == "facet_queries" ? data.key : ("{!tag=" + facet.name + "}" + facet.name + ":" + data.key);
    var selector = f.name;
    var idx = active.indexOf(selector);
    if (idx >= 0){
        search_model.faceting.active.splice(idx, 1);
        f.selected = false;
    } else {
        var range = [start, end];
        if (!range || (!range[0] && !range[1])) {
            f.selected = false;
        } else {
            var start = "*", end="*";
            if (range[0]) {
                start = range[0].toISOString();
            }
            if (range[1]) {
                end = range[1].toISOString();
            }
            var caption = null;
            if (range[0] && range[1]) {
                caption = moment(range[0]).format("L") + " - " + moment(range[1]).format("L");
            } else if (range[0]) {
                caption = _("search_facet_daterange_after_date", "After {0}").format(moment(range[0]).format("L"));
            } else {
                caption = _("search_facet_daterange_before_date", "Before {0}").format(moment(range[1]).format("L"));
            }
            search_model.faceting.active.push({
                "name": f.name,
                "value": "[" + start + " TO " + end + "]",
                "valueCaption": caption,
                "selector": (f.field || f.name)+":"+"[" + start + " TO " + end + "]",
                "caption": facet.caption,
                "join": facet.join,
                range: range
            });
            f.selected = true;
        }
    }
    search_model.pager.start_index(0);
    search_model.query_results();
};
this.selectBefore = function() {
    this.select_range(null, moment(f.before()));
}
this.selectAfter = function() {
    this.select_range(moment(f.after()), null);
}
this.selectFacet = function() {
    var data = this.data();
    if (data != null) {
        this.select_range(data[0], data[1])
    }
}

this.expanded = ko.observable(expanded);
this.expand = function () {
    f.expanded(!f.expanded());
};

}
export default DateRangeFacet;